"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.segmentTransform = void 0;
/**
 * Extract segment name as a plain string.
 */
function segmentTransform(segment) {
    return segment ? segment.segmentName : undefined;
}
exports.segmentTransform = segmentTransform;
